<template lang="pug">
b-modal#editMiniGameOp(
  ref="editMiniGameOp"
  :title="$t('ui.combine.edit_mini_game')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.game_name')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="game_name"
        required
        type="text"
        v-model="game_name"
      )
    template(v-if="isMiniGameTemplateHide == 'false'")
      b-form-group(:label="$tc('ui.template')").mb-1
        MiniGameTemplateLookup(
          ref="template_code"
          size="sm"
          required
          type="array"
          :gameId="game_id"
          :disabled="loading"
          :dirty="$v.template_code.$dirty"
          :error="$v.template_code.$error"
          v-model.trim.lazy="$v.template_code.$model"
          :key="templateKey"
        )
        ValidateResult(:value="$v.template_code" :name="$t('ui.template')")
    b-form-group(:label="$t('ui.token_request')").mb-1
      DebounceInput(
        size="sm"
        ref="token_request"
        required
        type="number"
        :dirty="$v.token_request.$dirty"
        :error="$v.token_request.$error"
        v-model.trim.lazy="$v.token_request.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.token_request" :name="$t('ui.token_request')" :fvalue="'0'")
    b-form-group(:label="$t('ui.payout_method')").mb-0
      PayoutMethod(
        ref="payout_method"
        size="sm"
        required
        type="array"
        :dirty="$v.payout_method.$dirty"
        :error="$v.payout_method.$error"
        v-model.trim.lazy="$v.payout_method.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.payout_method" :name="$t('ui.payout_method')")
    b-form-group(v-if="['INBOX'].includes(payout_method)" :label="$t('ui.campaign_id')").mb-0
      CampaignLookup(
        size="sm"
        ref="campaign_id"
        required
        type="array"
        :dirty="$v.campaign_id.$dirty"
        :error="$v.campaign_id.$error"
        v-model.trim.lazy="$v.campaign_id.$model"
        :disabled="loading"
        :operatorID="selectedOperatorID"
      )
      ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    b-form-group(:label="$t('ui.status')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="is_enable")
        span.custom-switch-indicator

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import MiniGameTemplateLookup from "@/library/MiniGameTemplateLookup";
import DebounceInput from "@/library/DebounceInput";
import PayoutMethod from "@/library/PayoutMethod";
import CampaignLookup from "@/library/CampaignLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    MiniGameTemplateLookup,
    DebounceInput,
    PayoutMethod,
    CampaignLookup
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      game_name: null,
      template_code: '',
      is_enable: true,
      game_id: null,
      templateKey: 0,
      isMiniGameTemplateHide: config.isMiniGameTemplateHide,
      token_request: 0,
      payout_method: "",
      campaign_id: ""
    };
  },
  computed: {
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    template_code: {
      required: requiredIf(function () {
        return this.isMiniGameTemplateHide == 'false';
      })
    },
    token_request: {
      required,
      mustMoreThan: function(value) {
        if(parseFloat(value) <= 0) return false
        return true
      }
    },
    payout_method: {
        required
      },
    campaign_id: {
      required: requiredIf(function () {
        return ['INBOX'].includes(this.payout_method);
      })
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editOperatorMiniGameUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          operator_game_id: this.item.operator_game_id,
          enable: this.is_enable,
          token_request: this.token_request,
          payout_method: this.payout_method,
          campaign_id: ['INBOX'].includes(this.payout_method) ? this.campaign_id : ""
        };

        if(this.isMiniGameTemplateHide == 'false') {
          json.selected_template = this.template_code
        }

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_mini_game", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editMiniGameOp.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editMiniGameOp.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
              this.$emit("failed", "edit_mini_game", this.feedback.status);
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.handleFeedback(this.feedback.status);
            this.$emit("failed", "edit_mini_game", this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.is_enable = true;
      this.feedback.success = true;
      this.feedback.status = "";
      this.game_name = '';
      this.payout_method = "";
      this.campaign_id = ""
      if(this.isMiniGameTemplateHide == 'false') {
        this.template_code = "";
        this.templateKey = 0;
      }
    },
    shown() {
      this.is_enable = this.item.status;
      this.game_name = this.item.game_name
      this.game_id = this.item.game_id;
      this.token_request = this.item.token_request;
      this.payout_method = this.item.payout_method;
      if(['INBOX'].includes(this.payout_method)) this.campaign_id = this.item.campaign_id
      else this.campaign_id = "";

      this.$v.$reset();
      if(this.isMiniGameTemplateHide == 'false') {
        this.templateKey += 1;
        this.template_code = this.item.current_template;
        this.$refs.template_code.$el.focus();
      }
    }
  }
};
</script>
